<script lang="ts">
  import { richTextFormatter } from '$lib/helpers/richTextHelper';
  import type { AuthorPanel } from '$lib/types/articleTypes';
  export let authorPanel: AuthorPanel;
  export let authorSummary: boolean = false;

  $: containerClass = authorSummary
    ? 'items-center'
    : 'pt-6 pb-8 border-y border-gray-200 lg:gap-4 lg:pt-8';

  $: titleClass = authorSummary ? 'text-sm' : 'text-md';
</script>

<section class="flex flex-row gap-3 {containerClass}">
  <div>
    <div class="w-12 h-12 lg:w-14 lg:h-14">
      <img
        src="{authorPanel?.image?.url}?w=300&q=85&fm=webp"
        alt={authorPanel?.image?.title}
        class="rounded-full border-[0.75px] border-gray-300 border-solid w-full h-full"
      />
    </div>
  </div>
  <div class="max-w-[40.5rem]">
    <b class="text-gray-900 font-semibold {titleClass} lg:text-lg">{authorPanel?.name}</b>
    <slot name="description">
      <p>{@html richTextFormatter(authorPanel?.bio)}</p>
    </slot>
  </div>
</section>
